import styled, { css } from 'styled-components';
import { IconCross } from '../../../common/components/icons/IconCross';
import { IconDropDown } from '../../../common/components/icons/IconDropDown/IconDropDown';
import { Filter as FilterIcon } from '../../../common/components/icons/outlined/Filter';
import { HeColours } from '../../../common/styles/HeColours';
import { ThemeColours } from '../../../common/styles/ThemeColours';
import {
  FontWeight,
  FONT_STACK,
  STANDARD_SHRINK,
  STANDARD_TRANSITION,
} from '../../../common/styles/constants';
import { HIDE_SCROLL_BAR } from '../../../common/styles/mixins';

interface PillProps {
  selected?: boolean;
  hasValue?: boolean;
}

export const Pill = styled.button<PillProps>`
  ${FONT_STACK};
  ${STANDARD_TRANSITION};
  ${HIDE_SCROLL_BAR};
  align-items: center;
  background-color: ${ThemeColours.white};
  border: 1px solid ${ThemeColours.mono300};
  border-radius: 100px;
  box-sizing: border-box;
  color: ${ThemeColours.mono700};
  cursor: pointer;
  display: flex;
  flex: 0 0 auto;
  font-size: 14px;
  font-weight: ${FontWeight.SEMI_BOLD};
  height: 40px;
  line-height: 19px;
  padding: 0 16px;
  user-select: none;

  ${props =>
    (props.hasValue || props.selected) &&
    css`
      background-color: ${ThemeColours.primary500};
      border-color: ${ThemeColours.primary500};
      color: ${ThemeColours.white};
    `}

  &:hover {
    border-color: ${ThemeColours.primary500};
  }

  &:focus {
    outline: none;
  }

  &:active {
    filter: brightness(${STANDARD_SHRINK});
    transform: scale(${STANDARD_SHRINK});
  }
`;

export const DropDownIcon = styled(IconDropDown)`
  height: 24px;
  margin-inline-start: 8px;
  width: 24px;
`;

export const CrossIcon = styled(IconCross)`
  background-color: #349ca8;
  border-radius: 24px;
  flex: 0 0 16px;
  height: 16px;
  margin-inline-start: 8px;
  width: 16px;

  &:hover {
    background: ${ThemeColours.white};
    color: ${ThemeColours.primary700};
  }
`;

export const StyledFilterIcon = styled(FilterIcon)`
  height: 16px;
  margin-inline-end: 4px;
  width: 16px;
`;

export const AppliedFilterCount = styled.span`
  align-items: center;
  background: ${ThemeColours.white};
  border-radius: 8px;
  color: ${HeColours.blue[500]};
  display: flex;
  font-size: 12px;
  font-weight: ${FontWeight.SEMI_BOLD};
  height: 16px;
  justify-content: center;
  margin-inline-end: 4px;
  width: 16px;
`;

export const ValueCaption = styled.span`
  flex: 0 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
